/**
 * Angular `security_notifcation` flag (typo preserved for shared storage parity).
 * Set to `'true'` after successful login; cleared after the toast check runs.
 */
import { SECURITY_NOTIFICATION_FLAG_KEY } from './sessionKeys'

export { SECURITY_NOTIFICATION_FLAG_KEY } from './sessionKeys'

export function markSecurityNotificationPending(): void {
  try {
    localStorage.setItem(SECURITY_NOTIFICATION_FLAG_KEY, 'true')
  } catch {
    /* non-fatal */
  }
}

export function isSecurityNotificationPending(): boolean {
  try {
    return localStorage.getItem(SECURITY_NOTIFICATION_FLAG_KEY) === 'true'
  } catch {
    return false
  }
}

export function clearSecurityNotificationPending(): void {
  try {
    localStorage.setItem(SECURITY_NOTIFICATION_FLAG_KEY, 'false')
  } catch {
    /* non-fatal */
  }
}
